import { Modals, useModals } from "@/hooks/useModals"
import Modal from "@/components/Modal"
import { DialogTitle } from "@headlessui/react"
import { Share } from "@/components/icons"
import Button from "@/components/Button"
import pwaImg from "@/assets/img/pwa.png?as=picture&w=256;512&format=png;webp;avif&imagetools"
import Image from "@/components/Image"

const PWAModal = () => {
  const { activeModal, closeModal } = useModals()
  const isOpen = activeModal === Modals.PWA

  return (
    <Modal show={isOpen} onClose={closeModal} hideHeader>
      <div className="from-chessdrop-400 via-chessdrop-400 to-chessdrop-500 -mx-4 -mt-5 bg-gradient-to-b pb-6 sm:-mx-6 sm:-mt-6">
        <Image
          image={pwaImg}
          alt=""
          width={256}
          height={129}
          className="mx-auto block w-64 object-contain"
          sizes="256px"
        />
      </div>
      <div className="pt-4">
        <DialogTitle className="text-lg font-semibold tracking-tight text-gray-900">
          Add ChessDrop to your home screen
        </DialogTitle>
        <p className="mt-2 text-base text-balance text-gray-600">
          Tap the{" "}
          <Share className="-mt-1.5 inline-block size-5 text-[#007AFF]" /> and
          then{" "}
          <span className="font-medium text-gray-900">
            &ldquo;Add to Home Screen&rdquo;
          </span>
        </p>
        <Button
          onClick={closeModal}
          className="mt-4"
          fullWidth
          style="secondary"
        >
          Close
        </Button>
      </div>
    </Modal>
  )
}

export default PWAModal
